import React, { useMemo } from "react";
import DiscountAdjustment from "./adjustmentTypeComponents/DiscountAdjustment";
import { useTicket } from "../../store/Store";
import Appointments from "./adjustmentTypeComponents/Appointments";
import Memberships from "./adjustmentTypeComponents/Memberships";
import Packages from "./adjustmentTypeComponents/Packages";
import GiftCards from "./adjustmentTypeComponents/GiftCards";
import Products from "./adjustmentTypeComponents/Products";
import Classes from "./adjustmentTypeComponents/Classes";
import { DiscountsIcon } from "../general/Icons";
import { useTranslation } from "react-i18next";
import CancellationFees from "./adjustmentTypeComponents/CancellationFeeAdjustments";
import MiscItems from "./adjustmentTypeComponents/MiscItems";

const AdjustmentsList = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const discountAdjustments = useMemo(() => {
    const giftCards = ticketData?.resource?.payment_items?.filter(
      (item) => item?.payment?.code_type === "GiftCard"
    );

    const giftCardDiscountItems = giftCards?.map((item) => (
      <DiscountAdjustment
        label={item?.payment?.coupon_code}
        amount={item?.payment?.amount}
        refunds={item?.refunds}
        type="giftcard"
      />
    ));

    if (!giftCardDiscountItems?.length) {
      return null;
    }

    return <>{giftCardDiscountItems}</>;
  }, [ticketData]);

  if (!ticketData?.resource?.adjustments) {
    return null;
  }

  return (
    <div data-testid="adjustments-list">
      <div className="min-w-full divide-y divide-gray-200">
        <Appointments />
        <Classes />
        <Memberships />
        <Packages />
        <GiftCards />
        <Products />
        <MiscItems />
        <CancellationFees />
        {discountAdjustments && (
          <div className="py-4">
            <div className="flex items-center gap-2 mb-2">
              <DiscountsIcon />
              <h3 className="text-lg font-medium text-black">
                {t("discounts.title")}
              </h3>
            </div>
            <div className="space-y-3">{discountAdjustments}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdjustmentsList;
